export function Spinner({ large = false }: { large?: boolean }) {
  return (
    <span
      className={large ? 'spinner spinner-lg' : 'spinner'}
      role="status"
      aria-label="Loading"
    />
  );
}
